import EmailComponent from './Email';
export default EmailComponent;